import { render, staticRenderFns } from "./PrestationCategoriesTable.vue?vue&type=template&id=3ccc83a0&scoped=true"
import script from "./PrestationCategoriesTable.vue?vue&type=script&lang=js"
export * from "./PrestationCategoriesTable.vue?vue&type=script&lang=js"
import style0 from "./PrestationCategoriesTable.vue?vue&type=style&index=0&id=3ccc83a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc83a0",
  null
  
)

export default component.exports